export class CompletedUpload {
	public originalFileId?: string;
	public fileName: string;
	public fileSize?: number;
	public documentId: string;
	public uploadId: string;
	public lexbeUploadBatchId: string;
	public partETags: any[];
}

